import { render, staticRenderFns } from "./ExpireDateAddEdit.vue?vue&type=template&id=2389d426&"
import script from "./ExpireDateAddEdit.vue?vue&type=script&lang=js&"
export * from "./ExpireDateAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports